import { ReactNode } from 'react'

import { Th, ThProps } from 'app/common/ui-components/table'

export type CommonRenderHeaderCellProps<
  TH extends Record<string, unknown>,
  K extends keyof TH & string = keyof TH & string,
> = {
  columnKey: K
  headerRowData: TH
  headerRowIndex: number
  headerCollumnIndex: number
  headerCellProps?: Partial<ThProps>
}

export type CommonRenderHeaderCell<
  TH extends Record<string, unknown>,
  K extends keyof TH & string = keyof TH & string,
> = (props: CommonRenderHeaderCellProps<TH, K>) => ReactNode

export const defaultRenderHeaderCell = <
  TH extends Record<string, unknown>,
  K extends keyof TH & string,
>({
  columnKey,
  headerRowData,
  headerRowIndex,
  headerCollumnIndex,
  headerCellProps,
}: CommonRenderHeaderCellProps<TH, K>) => {
  return <Th {...headerCellProps}>{headerRowData[columnKey] as ReactNode}</Th>
}
